import { cn } from 'components/UI/cn'
import { BsXCircleFill } from 'react-icons/bs'

export function FilterCloseButton(props: {
  isActive: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}) {
  return (
    <div className="absolute top-0 bottom-0 right-0 flex items-center justify-center">
      <button
        type={'button'}
        className={cn(
          'flex items-center justify-center cursor-pointer bg-transparent border-none p-0',
          'my-[13.5px] mr-[15.5px]',
          {
            hidden: !props.isActive,
          }
        )}
        onClick={(e) => {
          e.stopPropagation()
          props.onClick?.(e)
        }}
      >
        <BsXCircleFill className="w-[13px] h-[13px] text-new-company-gray-inactive" />
      </button>
    </div>
  )
}
